import React from "react";
import { LegalLayout, LegalSection } from "./LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      current="/confidentialite"
      title="Politique de confidentialité"
      subtitle="Conforme à la Loi 25 du Québec (Loi modernisant des dispositions législatives en matière de protection des renseignements personnels)."
      updated="Juillet 2026"
    >
      <LegalSection id="responsable" title="1. Responsable de la protection des renseignements personnels">
        <p>
          PROGÈRE, exploité par <strong className="text-white">Groupe MJR Construction Inc.</strong> (« PROGÈRE », « nous »),
          accorde une grande importance à la protection de vos renseignements personnels. Conformément à la Loi 25, nous avons
          désigné un responsable de la protection des renseignements personnels.
        </p>
        <p>
          <strong className="text-white">Responsable :</strong> [Nom du responsable à compléter]<br />
          <strong className="text-white">Courriel :</strong> confidentialite@progere.ca<br />
          <strong className="text-white">Adresse :</strong> [Adresse de l'entreprise à compléter], Québec, Canada
        </p>
      </LegalSection>

      <LegalSection id="collecte" title="2. Renseignements que nous recueillons">
        <p>Dans le cadre de la fourniture de nos services, nous pouvons recueillir&nbsp;:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Renseignements d'identification : nom, courriel, entreprise, fonction.</li>
          <li>Renseignements de compte : identifiants de connexion, préférences, rôles et permissions.</li>
          <li>Renseignements d'affaires saisis dans les modules (clients, chantiers, employés, feuilles de temps, factures).</li>
          <li>Renseignements de paiement traités par notre fournisseur Stripe (nous ne stockons pas les numéros de carte).</li>
          <li>Données techniques : adresse IP, type d'appareil, journaux d'accès, témoins (cookies).</li>
        </ul>
      </LegalSection>

      <LegalSection id="finalites" title="3. Finalités de la collecte">
        <p>Nous utilisons vos renseignements uniquement pour&nbsp;:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Fournir, maintenir et sécuriser l'accès aux modules PROGÈRE.</li>
          <li>Gérer votre abonnement, la facturation et les taxes applicables (TPS/TVQ).</li>
          <li>Offrir le support technique et communiquer avec vous.</li>
          <li>Améliorer nos services et assurer la conformité légale et réglementaire.</li>
        </ul>
        <p>Nous ne vendons jamais vos renseignements personnels à des tiers.</p>
      </LegalSection>

      <LegalSection id="consentement" title="4. Consentement">
        <p>
          En créant un compte ou en utilisant nos services, vous consentez à la collecte et au traitement de vos renseignements
          conformément à la présente politique. Vous pouvez retirer votre consentement en tout temps, sous réserve des obligations
          légales et contractuelles applicables.
        </p>
      </LegalSection>

      <LegalSection id="temoins" title="5. Témoins (cookies)">
        <p>
          Nous utilisons des témoins essentiels au fonctionnement (session, sécurité) et, avec votre accord, des témoins optionnels
          (préférences, mesure d'audience). Vous pouvez gérer vos préférences via la bannière de témoins affichée lors de votre visite.
        </p>
      </LegalSection>

      <LegalSection id="hebergement" title="6. Hébergement et communication hors Québec">
        <p>
          Vos renseignements sont hébergés au Canada. Si un renseignement devait être communiqué à l'extérieur du Québec, une évaluation
          des facteurs relatifs à la vie privée serait réalisée afin d'assurer une protection adéquate, conformément à la Loi 25.
        </p>
      </LegalSection>

      <LegalSection id="conservation" title="7. Conservation et destruction">
        <p>
          Nous conservons vos renseignements aussi longtemps que nécessaire aux finalités décrites, ou selon les délais exigés par la loi.
          Lorsqu'ils ne sont plus requis, ils sont détruits ou anonymisés de façon sécuritaire.
        </p>
      </LegalSection>

      <LegalSection id="droits" title="8. Vos droits">
        <p>Conformément à la Loi 25, vous avez le droit&nbsp;:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>D'accéder à vos renseignements personnels et d'en obtenir une copie.</li>
          <li>De demander la rectification de renseignements inexacts ou incomplets.</li>
          <li>De demander la portabilité de vos renseignements dans un format technologique structuré.</li>
          <li>De retirer votre consentement et de demander la cessation de la diffusion.</li>
          <li>De déposer une plainte auprès de la Commission d'accès à l'information du Québec (CAI).</li>
        </ul>
        <p>Pour exercer vos droits, écrivez-nous à confidentialite@progere.ca.</p>
      </LegalSection>

      <LegalSection id="incident" title="9. Incident de confidentialité">
        <p>
          En cas d'incident de confidentialité présentant un risque de préjudice sérieux, nous vous en aviserons ainsi que la CAI dans
          les meilleurs délais, et tiendrons un registre des incidents conformément à la Loi 25.
        </p>
      </LegalSection>

      <LegalSection id="contact-conf" title="10. Nous joindre">
        <p>
          Pour toute question relative à cette politique ou à la protection de vos renseignements personnels, contactez notre responsable
          à confidentialite@progere.ca.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
